var irreducible = require('./irreducible');
var isString = require('./isString');

module.exports = irreducible('String', isString);



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/String.js
// module id = 175
// module chunks = 114276838955818